import { IClientFile } from 'wisestep-api';

import { clientSettingsDefaultPayload } from '../../clientsSettings/helper/ClientSettingsHelper';

export const defaultClientFilePayload: IClientFile = {
  id: '',
  clientId: '',
  clientContactId: '',
  file: { name: '', location: '' },
  category: clientSettingsDefaultPayload,
  entityId: '',
  createdBy: '',
  modifiedBy: '',
  createdOn: null,
  modifiedOn: null,
  createdByName: '',
};
